import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle';
import FormSH from '../../../library/form/components/FormSH';
import FormRadioButton from '../../../library/form/components/FormRadioButton';
import { UiGridColTwo, UiCol, UiRow } from "../../../library/layout/Index";


const ProContactEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} formObject={formObject} contentStyle={{ height: '375px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Profile Contact" />}
        >
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "conType" }} value="Contact Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" autofocus className=""
                                    action={{ InputType: "ac", paramName: "conType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "conType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                    >
                                </FormSH>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "conTitle" }} value="Title" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="titleTxt" className=""
                                    action={{ InputType: "ac", paramName: "conTitle", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "conTitle",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                     >
                                </FormSH>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="firstNameTxt" className=""
                                    action={{ InputType: "input", paramName: "firstName" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="middleNameTxt" className=""
                                    action={{ InputType: "input", paramName: "middleName" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="lastNameTxt" className=""
                                    action={{ InputType: "input", paramName: "lastName" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "landline1" }} value="Landline 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="landline1Txt" className=""
                                    action={{ InputType: "input", paramName: "landline1" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "landline2" }} value="Landline 2" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="landline2Txt" className=""
                                    action={{ InputType: "input", paramName: "landline2" }}
                                />
                            </div>
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <div className="uiRow uiSpacer" id="svMobileNotify" >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobileNotifyOff" }} value="Mobile Notification" />
                                </span>
                                <FormRadioButton formObject={formObject} rowKey="" text="Turn Off" name="mNotify" radioKey="notifyOff"
                                    action={{ InputType: 'switch', paramName: "mobileNotify" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="mobile1Txt" className=""
                                    action={{ InputType: "input", paramName: "mobile1" }}
                                />
                                <div className="uiInline" id="svMobile1Notify" >
                                    <FormRadioButton formObject={formObject} rowKey="" text="Notify" name="mNotify" radioKey="notifyMobile1"
                                        action={{ InputType: 'switch', paramName: "mobileNotify" }}
                                    />
                                </div>
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile2" }} value="Mobile 2" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="mobile2Txt" className=""
                                action={{ InputType: "input", paramName: "mobile2" }}
                            />
                            <div className="uiInline" id="svMobile2Notify" >
                                <FormRadioButton formObject={formObject} rowKey="" text="Notify" name="mNotify" radioKey="notifyMobile2"
                                    action={{ InputType: 'switch', paramName: "mobileNotify" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "whatsApp" }} value="Whatsapp No" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="whatsappTxt" className=""
                                    action={{ InputType: "input", paramName: "whatsApp" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div className="uiRow uiSpacer" id="svEmailNotify" >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "emailNotifyOff" }} value="Email Notification" />
                                </span>
                                <FormRadioButton formObject={formObject} rowKey="" text="Turn Off" name="eNotify" radioKey="notifyOff"
                                    action={{ InputType: 'switch', paramName: "emailNotify" }}
                                />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email 1" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="email1Txt" className=""
                                action={{ InputType: "input", paramName: "email1" }}
                            />
                            <div className="uiInline" id="svEmail1Notify" >
                                <FormRadioButton formObject={formObject} rowKey="" text="Notify" name="eNotify" radioKey="notifyEmail1"
                                    action={{ InputType: 'switch', paramName: "emailNotify" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email2" }} value="Email 2" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="email2Txt" className=""
                                    action={{ InputType: "input", paramName: "email2" }}
                                />
                                <div className="uiInline" id="svEmail2Notify" >
                                    <FormRadioButton formObject={formObject} rowKey="" text="Notify" name="eNotify" radioKey="notifyEmail2"
                                        action={{ InputType: 'switch', paramName: "emailNotify" }}
                                    />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="uiRow uiSpacer">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Set Default" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' id="proContactMakeDefault"
                                    action={{ InputType: "onOff", paramName: "isDefault" }}
                                />
                            </div>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <div>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="82"
                        action={{ paramName: "remarks" }}
                    />
                </div>
            </UiRow>
        </FormDialog>
    )
}

export default withView(ProContactEditor, "proContact", "proContact")